<template>
  <div class="error">
    <div class="error-title">{{title}}</div>
    <div class="error-content">{{content}}</div>
    <div class="error-link">
      <router-link to="/">
        主页
      </router-link>
      |
      <router-link to="/login">
        登录
      </router-link>
    </div>
    <div class="error-footer">
      &copy; {{year}} - 追溯管理平台
    </div>
  </div>
</template>
<script>
export default {
  props: ["title", "content"],
  name: "error",
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>

<style lang="scss" scoped>
.error {
  margin: 15% auto;
  text-align: center;
  * {
    padding: 10px;
  }
  .error-title {
    font-size: 50px;
    color: #666;
  }
  .error-content {
    font-size: 20px;
    color: #666;
  }
  .error-link {
    a {
      color: #888;
      &:hover {
        color: darken($color: #888, $amount: 20%)
      }
    }
    padding: 20px;
  }
  .error-footer {
    color: #888;
  }
}
</style>






// WEBPACK FOOTER //
// src/components/common/error.vue